<template>
  <el-row class="pa-2">
    <el-col :span="24" class="text-center">
      <div class="close-icon-head" @click="redirectToMenu">
        <i class="el-icon-back"></i>
      </div>
      <el-image 
          v-if="BranchDetail"
          class="big-logo"
          :src="'https://images.foodstory.co/' + BranchDetail.logo"
          fit="cover"></el-image>
    </el-col>
    <el-col :span="24" class="text-center auth-text">
      <h3>{{ $t('verifyinfo.text') }}</h3>
    </el-col>
    <el-col class="p-36">
      <el-form :model="UserValidateForm" ref="UserValidateForm" class="demo-ruleForm">
        <el-form-item
          prop="username"
          :rules="[
            { required: true, message: 'username is required'}
          ]"
        >
        <label for="username" >{{ $t('verifyinfo.name') }}</label>
          <el-input type="username" id="username" height="50" :placeholder="$t('verifyinfo.placeholder')" v-model="UserValidateForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-auth-phone" @click="authusername('UserValidateForm')">{{ $t('verifyinfo.success') }}</el-button>
        </el-form-item>
      </el-form>
    </el-col>

  </el-row>
</template>
<script>
export default {
  name: 'Authusername',
  props: ['restaurant_uuid', 'branch_uuid'],
  data () {
    return {
      username: null,
      UserValidateForm: { username: '' }
    }
  },
	methods: {
    authusername(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('updateUserInfo', {
            restaurant_uuid: this.BranchDetail.restaurantId,
            branch_uuid:this.BranchDetail.id,
            username: this.UserValidateForm.username
          }).then((update) => {
            if (!update) {
              return false;
            }
          })
        } else {
          return false;
        }
      })
    },
    redirectToMenu () {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/verify/VerifyInfo.vue